import { Component, Input } from '@angular/core';
import { Basket } from '@modules/checkout-store';

@Component({
  selector: 'nx-ng-summary-totals',
  templateUrl: './summary-totals.component.html',
  styleUrls: ['./summary-totals.component.scss'],
})
export class SummaryTotalsComponent {
  @Input()
  basket: Basket | undefined | null = null;

  @Input()
  subtotalBasketPrice: Basket["basketTotal"] | null = null;

  @Input()
  totalBasketPrice: Basket["toPayBasketTotal"] | null = null;
}
